import React from 'react';
import './Phase0.css';
import { POINT_SYSTEM } from '../../constants';
import PointSummary from '../PointSummary/PointSummary';

const Phase0 = ({ preseasonWinner, onPreseasonWinnerChange, isSaved, onSaveGuess, teams }) => {
  return (
    <div className="phase-container">
      <h3>Fase 0 - Gæt Vinderen</h3>
      {isSaved ? (
        <div className="saved-status">
          <p>✅ <strong>Gæt gemt!</strong> Du har valgt: <strong>{preseasonWinner}</strong></p>
          <p>Dette gæt kan ikke ændres.</p>
        </div>
      ) : (
        <p>Vælg hvem du tror vinderen af Champions League bliver:</p>
      )}
      <div className="team-selection">
        {teams.map((team, index) => (
          <button
            key={index}
            className={`team-button ${preseasonWinner === team ? 'selected' : ''} ${isSaved ? 'disabled' : ''}`}
            onClick={() => {
              if (!isSaved) {
                onPreseasonWinnerChange(team);
              }
            }}
            disabled={isSaved}
          >
            {team}
          </button>
        ))}
      </div>
      {preseasonWinner && !isSaved && (
        <div className="selection-confirmation">
          <p>Valgt vinder: <strong>{preseasonWinner}</strong></p>
          <button 
            className="save-guess-button"
            onClick={onSaveGuess}
            title="Gem dit gæt - dette kan ikkes ændres senere!"
          >
            Gem Gæt
          </button>
        </div>
      )}
      
      <PointSummary
        rules={[
          { text: `Gæt på det hold som du tror vinder Champions League 25/26` },
          { text: `${POINT_SYSTEM.PRESEASON_WINNER} point hvis dit gæt vinder Champions League 25/26` },
          { text: `${POINT_SYSTEM.PRESEASON_FINALIST} point hvis dit gæt når finalen` }
        ]}
      />
    </div>
  );
};

export default Phase0;
